<template>
    <v-container app :fluid="true" class="padding-top-0 padding-bootom-0">
        <v-row v-if="!is_delivery_man">
            <v-col cols="12" class="padding-top-0 padding-bootom-0">
                <Summary/>
            </v-col>
        </v-row>
        <!--
        <v-row class="padding-top-0">
            <v-col :md="4" :sm="12" class="padding-top-0 pr-0 pb-2">                
                <Customers></Customers>
            </v-col>
            <v-col :md="8" :sm="12" class="padding-top-0 pr-0 padding-bootom-0">
                <Information/>
            </v-col>
        </v-row>
        -->
        <v-row class="pt-0 pb-0">
            <v-col :md="12" :sm="12" class="padding-top-0 pr-0 pb-0">                
                <list-orders></list-orders>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Summary from '../../components/Orders/Summary'
import Customers from '../../components/Orders/Customers'
import Information from '../../components/Orders/Information'
import ListOrders from '../../components/Orders/ListOrders';

export default {
    name: 'Orders',
    components: {
        //Customers,
        Summary,
        //Information,
        ListOrders
    },
    data() {
        return {
            user: null,
            is_delivery_man: false
        }
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('orders', [
            'listStatus',
        ]),
    },
    methods: {
        ...mapActions('cash', [
            'getCashCurrent'
        ]),
        ...mapActions('orders', [
            'getListStatusOrder',
        ]),
        setDataUser(){
            this.user = this.$identifiedUser()
            this.is_delivery_man = this.$isDeliveryMan()
        }
    },
    created () {
        this.getCashCurrent();
    },
    mounted() {
        this.setDataUser()
        this.getListStatusOrder()        
    }
}
</script>

<style>
.content-detail{
    border-radius: 15px !important;
}

.section-customer-order{
    padding: 5px !important;
}
</style>